<template>
   <div class="wrap">
        <img src="../../assets/imgs/loading.gif" alt />
    </div>
</template>

<script>
export default {
    data(){
        return{
            url: "", // 登录成功后跳转到原地址
        };
    },
    created(){
        this.url = this.$route.query.url // 原网页地址，登录成功后跳转到原网页
        this.ipOrAccount();
    },
    methods:{
        //检查ip登录还是账号名登录
        ipOrAccount(){
            if(this.$cookies.getCookie("token")){
                this.$router.push({
                    name:"index"
                });
            }else{
                if(!this.url){
                    this.url = "index"
                }
                this.$http({
                    method:"POST",
                    url:"IPLogin",
                }).then(res => {
                    if(Object.prototype.toString.call(res.data) == '[object Array]'){
                        // IP段设置多个机构，选择机构登录
                        this.$router.replace({
                            name: 'login',
                            query: {
                                url: this.url,
                                loginType: 'selectOrgan'
                            }
                        })
                    }else{
                        // IP登录成功
                        this.$cookies.loginSetCookie(res.data)
                        this.$router.replace({
                            path: this.url
                        });                        
                    }       
                })
                .catch(err => {
                    // IP段不在范围内
                    this.$router.replace({
                        path: "/404"
                    });
                });
            }
        }
    }

}
</script>

<style  scoped>
.wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50px;
    margin-top: -25px; /* 高度的一半 */
    margin-left: -25px; /* 宽度的一半 */
}
</style>


// WEBPACK FOOTER //
// src/page/check/index.vue